import { Injectable } from '@angular/core';
import { Part } from 'app/core/model/entity-model';
import { GenesisUnitOfWork } from 'app/core/data/genesis-unit-of-work';
import { PartPurchaseDialogComponent } from 'app/shared/part-purchase-dialog/part-purchase-dialog.component';
import _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';

@Injectable()
export class PartPurchaseRepository {
    constructor(private uow: GenesisUnitOfWork, private modalService: BsModalService) {}

    async addPartPurchase(selectedPart: any): Promise<boolean> {
        console.log('selectedPart', selectedPart);
        if (!selectedPart.allocated || !selectedPart.projectedInventory) selectedPart = await this.getOrderLineDetailForPart(selectedPart);
        const modalRef = this.modalService.show(PartPurchaseDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                partId: selectedPart ? selectedPart.id : null,
                selectedPart: selectedPart ? selectedPart : null,
            },
        });

        const promise = new Promise<boolean>(async (resolve, reject) => {
            modalRef.content.result.subscribe(async (result) => {
                if (result.success) {
                    const part = (await this.uow.parts.byId(result.partId)) as Part;
                    part.inStock = result.quantity;
                    selectedPart.projectedInventory = result.quantity-selectedPart.allocated;
                    await this.uow.commit();
                    resolve(true);
                }

                resolve(false);
                modalRef.hide();
            });
        });

        return promise;
    }

    // get the quantity fields for the dialog screen
    async getOrderLineDetailForPart(part: any): Promise<any> {
        const orderLinePartsNew = await this.uow.getOrderLineDetailPartsOnNew();
        const orderLinePartInfo = _.find(orderLinePartsNew, { partId: part.id }) as any;
        part.allocated = !!orderLinePartInfo ? orderLinePartInfo.partCountOnNewStatus : 0;
        part.projectedInventory = part.inStock + part.onOrderNew;
        return part;
    }
}
